import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Zap } from 'lucide-react';

const fmtTime = (iso) => {
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

/** Recent trigger events across all of the user's alerts. */
const AlertHistoryCard = ({ events }) => {
  if (!events?.length) return null;
  return (
    <Card className="mb-8" data-testid="alert-history-card">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Zap size={16} className="text-amber-500" /> Recent Triggers
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {events.map((e) => (
            <div
              key={e.id}
              className="flex items-center justify-between p-2.5 border border-gray-100 rounded-lg text-sm"
              data-testid={`alert-event-${e.id}`}
            >
              <div className="flex items-center gap-2 min-w-0">
                <Badge
                  className={
                    e.change_pct >= 0
                      ? 'bg-emerald-100 text-emerald-700'
                      : 'bg-red-100 text-red-700'
                  }
                >
                  {e.symbol}
                </Badge>
                <span className="text-gray-700 truncate">
                  ${Number(e.price).toFixed(2)} ({e.change_pct >= 0 ? '+' : ''}
                  {e.change_pct}%)
                </span>
                {e.note && <span className="text-gray-400 text-xs truncate">· {e.note}</span>}
              </div>
              <span className="text-xs text-gray-400 flex-shrink-0 ml-2">{fmtTime(e.triggered_at)}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default AlertHistoryCard;
